/*************************************************************************
* Copyright (c) 2025 Omnineura AI Technologies Pvt Limited.
* All rights reserved.
* This code is licensed under the 'Omnineura AI License' found in the LICENSE file.
* Unauthorized copying, sharing, or use of this code is prohibited.
* The intellectual and technical concepts are proprietary to Omnineura AI Technologies Pvt Limited.
* Author: surya@Omnineura.ai
* Date: 11-09-2025
*************************************************************************/

import axios from "axios";
const API_BASE_URL = process.env.REACT_APP_BASE_URL;
console.log("API BASE URL:", process.env.REACT_APP_BASE_URL);


export const registerUser = async (userData) => {
  try {
    const { username, email, first_name, last_name, password } = userData;
    const response = await axios.post(`${API_BASE_URL}/auth/create-user`, {
      username,
      email,
      first_name,
      last_name,
      password,
    });
    return response.data;


  } catch (error) {
    throw error.response?.data || "Registration failed";
  }
};


// export const loginUser = async (credentials) => {
 
//   try {
//     const response = await axios.post(`${API_BASE_URL}/auth/login`, credentials,{ withCredentials: true });
//     return response.data;
//   } catch (error) {
//     if (error.response) {
//       throw error.response.data;
//     }
//     throw {
//       detail: "Unable to reach auth server. Check REACT_APP_BASE_URL/CORS for ngrok setup."
//     };
//   }
// }; 

export const loginUser = async (credentials) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/auth/login`,
      credentials,
      { withCredentials: true }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      // Backend error
      const message =
        error.response.data?.detail ||
        error.response.data?.message ||
        "Login failed";

      throw new Error(message);
    }

    // Network / CORS / server unreachable
    throw new Error(
      "Unable to reach auth server. Check REACT_APP_BASE_URL/CORS for ngrok setup."
    );
  }
};

export const getGoogleLoginUrlApi = async () => {
  const response = await axios.get(`${API_BASE_URL}/auth/google-login-url`, {
    withCredentials: true,
  });
  return response.data;
};

